import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import  { ITerminalTaxResponse } from '../models/taxes.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Function the gets the individual terminal taxes
 * 
 * @param {string} terminalId the terminal id being queried
 */
export const getTerminalTaxes = async (terminalId: string): Promise<ITerminalTaxResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get(`/terminal/${terminalId}/tax`, {
      params: {
        wpID: userId,
        terminalID: terminalId
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting tax data');
    throw(error);
  }
}